import { takeLatest, put, select, call, all } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import type { DateYMDString } from '@lt/api/dist/types/date';

import { api } from 'src/api';

import { updateDate } from 'src/utils/dateUtils';

import { getSearchParamsRequestId } from 'src/store/enqueue/selectors';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  priceChartFetchingDirectionSelector,
  priceChartResultSelector,
} from './selectors';

import { COUNT } from './constants';

import {
  setPriceChart,
  fetching,
  paginationDirection,
  fetchPriceChart,
} from './slice';

function* getPriceChart(action: ReturnType<typeof fetchPriceChart>) {
  const {
    payload: { startDate },
  } = action;

  yield put(fetching());

  const requestId = yield select(getSearchParamsRequestId);
  const isHotelOnly = yield select(getIsHotelOnly);

  // для отелей не покатываем статистику цен и не делаем запрос
  if (isHotelOnly) {
    return;
  }

  try {
    const response = yield api.getSearchBlocksSearchPriceChart({
      request_id: requestId,
      start_date: startDate,
      range: COUNT,
    });

    if (!isEmpty(response?.result)) {
      yield put(setPriceChart(response));
    }
  } catch (error) {
    console.error(error);
  }
}

/**
 * Формируем новую дату для пагинации
 */
function* getPaginationParams() {
  const data = yield select(priceChartResultSelector);
  const direction = yield select(priceChartFetchingDirectionSelector);
  const isMobile = yield select(getIsMobile);

  const date = data.at(Math.round(COUNT / 2)).start_date;

  const daysCount = isMobile ? 7 : 14;

  const newStartDate = updateDate({ date, direction, daysCount });
  return newStartDate as DateYMDString;
}

function* priceChartPagination() {
  const startDate: SagaReturnType<typeof getPaginationParams> = yield call(
    getPaginationParams,
  );

  yield put(fetchPriceChart({ startDate }));
}

export default function* priceChartSaga() {
  yield all([
    takeLatest(fetchPriceChart.type, getPriceChart),
    takeLatest(paginationDirection.type, priceChartPagination),
  ]);
}
